import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SecretClass;
function Secret() {
  if (SecretClass === VOID) {
    class $ {
      constructor(id, description, createdTimestamp, lastUsedTimestamp) {
        this.f2d_1 = id;
        this.g2d_1 = description;
        this.h2d_1 = createdTimestamp;
        this.i2d_1 = lastUsedTimestamp;
      }
      toString() {
        return 'Secret(id=' + this.f2d_1.toString() + ', description=' + this.g2d_1 + ', createdTimestamp=' + this.h2d_1.toString() + ', lastUsedTimestamp=' + toString(this.i2d_1) + ')';
      }
      hashCode() {
        var result = this.f2d_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.g2d_1) | 0;
        result = imul(result, 31) + this.h2d_1.hashCode() | 0;
        result = imul(result, 31) + (this.i2d_1 == null ? 0 : this.i2d_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Secret()))
          return false;
        if (!this.f2d_1.equals(other.f2d_1))
          return false;
        if (!(this.g2d_1 === other.g2d_1))
          return false;
        if (!this.h2d_1.equals(other.h2d_1))
          return false;
        if (!equals(this.i2d_1, other.i2d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Secret');
    SecretClass = $;
  }
  return SecretClass;
}
//region block: exports
export {
  Secret as Secret2t4auo9luo6wh,
};
//endregion

//# sourceMappingURL=Secret.mjs.map
